import React, {useEffect, useRef, useState, useCallback} from 'react';
import {
    ActivityIndicator,
    CCText,
    FlatList,
    Image,
    TextInput,
    TouchableWithoutFeedback,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';
import TMenuScreen from "./Translations/TMenuScreen";
import AppConfig from '../../../AppConfig';
import PublicMenuItem from '../../../components/public/Menu/PublicMenuItem';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {
    BorderlessButton, DarkButton,
    FloatingButton,
    ThemeButton,
} from '../../../custom-packages/react-button-package/ButtonPackage';
import Styles from "../../../Styles";
import logo from './../../../assets/logo.png';

import {useDispatch, useSelector} from "react-redux";
import {GetAuthObject} from "../../../authentication/AuthFunctions";
import * as AuthActions from "../../../store/actions/authActions";
import CallWaiterModal from "../../../components/public/Menu/CallWaiterModal";
import WaiterIcon from "../../../assets/custom-icons/WaiterIcon";
import {GetTextColor, HexToRGBA} from "../../../ColorFunctions";

import './menu.scss';
import MenuHeaderTabs from "../../../components/public/Menu/MenuHeaderTabs";
import {RegisterEvent} from "../../../AnalyticsFunctions";
import {MenuHeader} from "../../../components/public/Menu/MenuHeader";
import TAuth from "../../auth/Translations/TAuth";
import BottomActionBar from "../../../custom-packages/contextual-action-bar/BottomActionBar";
import {GetHoursDifference} from "../../../LocalStorageFunctions";


function cleanString(input) {
    const tildeMap = {
        'á': 'a', 'Á': 'A',
        'é': 'e', 'É': 'E',
        'í': 'i', 'Í': 'I',
        'ó': 'o', 'Ó': 'O',
        'ú': 'u', 'Ú': 'U',
        'ñ': 'n', 'Ñ': 'N',
    };

    return input
        .replace(/./g, (char) => tildeMap[char] || char) // Replace letters with a tilde
        .replace(/[^\w\s]|_/g, '') // Remove special characters and underscore
        .replace(/\s+/g, ''); // Remove whitespaces
}

const PublicMenuScreen = (props) => {
    const auth = GetAuthObject();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const sectionRefs = useRef([]);
    const tabBarRef = useRef(null);

    const params = useParams()
    const menuID = params.id;
    const sessionID = new URLSearchParams(useLocation().search).get('sessionID');
    const testToken = new URLSearchParams(useLocation().search).get('testToken');

    const [menuBusinessID, setMenuBusinessID] = useState(null);
    const [loading, setLoading] = useState(true);
    const [searching, setSearching] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [pollID, setPollID] = useState(null);
    const [config, setConfig] = useState({});
    const [currentSection, setCurrentSection] = useState({});
    const [menuSections, setMenuSections] = useState([]);
    const [food, setFood] = useState([]);
    const [filteredFood, setFilteredFood] = useState([]);
    const [hideSearchBar, setHideSearchBar] = useState(false);
    const [userScrolled, setUserScrolled] = useState(false);
    const [isCallWaiterModalOpen, setIsCallWaiterModalOpen] = useState(false);
    const [menuNotFound, setMenuNotFound] = useState(false);
    const [subExpired, setSubExpired] = useState(false);
    const [pages, setPages] = useState(null);

    const toggleCallWaiterModal = () => {
        setIsCallWaiterModalOpen(!isCallWaiterModalOpen);
    }

    const useScroll = () => {
        const [scrollY, setScrollY] = useState(0);

        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        useEffect(() => {
            window.addEventListener("scroll", handleScroll);
            return () => window.removeEventListener("scroll", handleScroll);
        }, []);

        return scrollY;
    };

    const scrollY = useScroll();

    useEffect(() => {
        setHideSearchBar(scrollY > 1);
        selectCurrentSectionInView();

        if (userScrolled) {
            const resetUserScrolled = setTimeout(() => {
                setUserScrolled(false);
            }, 500);

            return () => {
                clearTimeout(resetUserScrolled);
            };
        }
    }, [scrollY]);

    const scrollToSelectedTab = (selectedTabIndex) => {
        if (tabBarRef.current && tabBarRef.current.children[selectedTabIndex]) {
            const tab = tabBarRef.current.children[selectedTabIndex];
            const tabLeft = tab.offsetLeft;
            const tabRight = tabLeft + tab.clientWidth;
            const scrollLeft = tabBarRef.current.scrollLeft;
            const viewportWidth = tabBarRef.current.clientWidth;

            if (tabLeft < scrollLeft) {
                // The selected tab is offscreen to the left
                tabBarRef.current.scrollLeft = tabLeft;
            } else if (tabRight > scrollLeft + viewportWidth) {
                // The selected tab is offscreen to the right
                tabBarRef.current.scrollLeft = tabRight - viewportWidth;
            }
        }
    };

    useEffect(() => {
        if (searchText && searchText.length > 2) {
            const lowerSearchText = searchText.toLowerCase();
            const filteredFood = food.filter((item) => {
                const name = item.name || '';
                const description = item.description || '';

                return (
                    name.toLowerCase().includes(lowerSearchText) ||
                    description.toLowerCase().includes(lowerSearchText)
                );
            });

            for (let i = 0; i < filteredFood.length; i++) {
                filteredFood[i].title = '';
            }

            setFilteredFood(filteredFood);
        } else {
            setFilteredFood([]);
        }
    }, [searchText]);

    const selectCurrentSectionInView = () => {
        if (!userScrolled) {
            const menuSectionsCopy = [...menuSections];
            let currentSectionInView = null;

            for (const sectionId in sectionRefs.current) {
                const sectionRef = sectionRefs.current[sectionId];
                if (sectionRef) {
                    const sectionPosition = sectionRef.getBoundingClientRect().top;
                    if (sectionPosition <= window.innerHeight / 2) {
                        currentSectionInView = sectionId;
                    }
                }
            }

            const index = menuSectionsCopy.findIndex(item => item.id == currentSectionInView);

            if (currentSectionInView && index > -1) {
                menuSectionsCopy.forEach((item) => {
                    item.selected = item.id == currentSectionInView;
                });

                setMenuSections(menuSectionsCopy);
                setCurrentSection(menuSectionsCopy[index])
                scrollToSelectedTab(index);
            }
        }
    };

    const registerSectionRef = (sectionId, ref) => {
        sectionRefs.current[sectionId] = ref;
    };

    useEffect(() => {
        const storedAuth = GetAuthObject();

        dispatch(AuthActions.saveAuth(storedAuth));

        const fetchInitialData = async () => {
            try {
                const response = await fetch(AppConfig.URL + '/PublicActions/FetchMenuContent/' + menuID, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': auth.token
                        },
                    }
                );

                let data = await response.json();

                if (data.subscriptionExpired) {
                    setSubExpired(true)
                    setLoading(false)

                    return;
                }

                if (data.menuNotFound) {
                    setMenuNotFound(true)
                    setLoading(false)

                    return;
                }

                if (data.config) {
                    setConfig(data.config)
                }

                if (data.pollID) {
                    setPollID(data.pollID)
                }

                if(data.businessID)
                    setMenuBusinessID(data.businessID)

                if (data.pages) {
                    setPages(data.pages)
                    setLoading(false)

                    return;
                }

                if (data.menuSections.length > 0)
                    data.menuSections[0].selected = true;

                let food = [];

                for (let i = 0; i < data.menuSections.length; i++) {
                    if (data.menuSections[i].food.length > 0) {
                        data.menuSections[i].food[0].title = data.menuSections[i].name;
                        data.menuSections[i].food[0].sectionDescription = data.menuSections[i].description;
                        data.menuSections[i].food[0].sectionId = data.menuSections[i].id;
                    }

                    food = food.concat(data.menuSections[i].food);
                }

                setLoading(false);
                setMenuSections(data.menuSections);
                setFood(food);
                setCurrentSection(data.menuSections[0]);

                if (testToken)
                    toggleCallWaiterModal();

                return;
            } catch (error) {
                console.error(error);

                setLoading(false);
            }
        }

        fetchInitialData();
    }, []);

    useEffect(() => {
        const storedAuth = GetAuthObject();

        RegisterEvent({
            source: window.location.href,
            sequenceID: AppConfig.ANALYTICS_SEQUENCE_PUBLIC_MENU,
            token: storedAuth.token,
        })
    }, []);


    if (loading || searching)
        return <View style={{paddingTop: 200}}>
            <View style={{justifyContent: 'center', alignItems: 'center'}}>
                <Image source={{uri: logo}} style={{width: 120}}/>
            </View>
            <ActivityIndicator style={{marginTop: 15}}/>
        </View>


    if (subExpired)
        return <View style={{paddingTop: 200}}>
            <CCText
                style={{textAlign: 'center'}}
            >
                {TMenuScreen[AppConfig.lang].SUB_EXPIRED}
            </CCText>
            <ThemeButton
                text={TAuth[AppConfig.lang].SIGNIN}
                to={'/auth?type=BUSINESS'}
                style={{marginTop: 30}}
            />
        </View>

    if (pages) {
        return <View>
            {
                pages.map(item => <div
                    className={'row'}
                >
                    <img
                        src={item.mpA_URL}
                        className={'col-12 col-md-6'}
                    />
                </div>)
            }
            {sessionID ?
                <FloatingButton
                    style={{backgroundColor: config.primaryColor}}
                    icon={<WaiterIcon
                        fill={GetTextColor(config.primaryColor)}
                        width={25}
                        height={25}
                    />}
                    onPress={toggleCallWaiterModal}
                />
                :
                null
            }
            <CallWaiterModal
                testToken={testToken}
                visible={isCallWaiterModalOpen}
                onRequestClose={toggleCallWaiterModal}
                sessionID={sessionID}
                config={config}
            />
        </View>
    }

    return (
        <View
            style={{
                fontFamily: config.fontFamily,
                backgroundColor: config.backgroundColor,
            }}
            className={'menu-screen'}
        >
            <View
                style={{
                    position: 'fixed',
                    left: 0,
                    right: 0,
                    top: 0,
                    minHeight: '100vh',
                    backgroundColor: config.backgroundColor,
                    zIndex: -9000
                }}
            >
            </View>
            <MenuHeader
                logo={config.logo}
                title={config.name}
                style={{
                    backgroundColor: config.primaryColor
                }}
            />
            <View
                className="ignore-container-margin"
            >
                <View
                    style={{
                        backgroundColor: config.backgroundColor,
                    }}
                    className={config.logo ? `search-bar-with-logo ${hideSearchBar ? "search-bar-hidden-with-logo" : ""}` : `search-bar ${hideSearchBar ? "search-bar-hidden" : ""}`}
                >
                    {!searchText && filteredFood.length == 0 ?
                        <MenuHeaderTabs
                            ref={tabBarRef}
                            menuSections={menuSections}
                            config={config}
                            setCurrentSection={setCurrentSection}
                            setMenuSections={setMenuSections}
                            sectionRefs={sectionRefs}
                            setUserScrolled={setUserScrolled}
                            currentSection={currentSection}
                        />
                        :
                        null
                    }
                </View>
            </View>
            <View
                className={config.logo ? 'content-with-logo' : 'content'}
            >
                {
                    !food || food.length == 0 ?
                        <View
                            style={{textAlign: 'center', fontSize: '1.5rem'}}
                        >
                            {TMenuScreen[AppConfig.lang].NO_FOOD}
                        </View>
                        :
                        null
                }
                {
                    menuNotFound ?
                        <View
                            style={{textAlign: 'center', fontSize: '1.5rem'}}
                        >
                            {TMenuScreen[AppConfig.lang].NOT_FOUND}
                        </View>
                        :
                        null
                }
                <FlatList
                    keyExtractor={item => {
                        return item.id;
                    }}
                    data={food}
                    renderItem={({item}) => {
                        return <PublicMenuItem
                            item={item}
                            registerSectionRef={registerSectionRef}
                            config={config}
                        />;
                    }}
                    ListHeaderComponent={() => {
                        return null;
                    }}
                    ListFooterComponent={() => {
                        return <View style={{height: 80}}></View>
                    }}
                />
                {sessionID ?
                    <FloatingButton
                        style={{backgroundColor: config.primaryColor}}
                        icon={<WaiterIcon
                            fill={GetTextColor(config.primaryColor)}
                            width={25}
                            height={25}
                        />}
                        onPress={toggleCallWaiterModal}
                    />
                    :
                    null
                }
            </View>
            <CallWaiterModal
                testToken={testToken}
                visible={isCallWaiterModalOpen}
                onRequestClose={toggleCallWaiterModal}
                sessionID={sessionID}
                config={config}
            />
            {
                auth
                &&
                auth.token
                &&
                (auth.role === "Bow" || auth.role === "Bad" || auth.role === "Adm")
                &&
                    menuBusinessID == auth.businessID
                    ?
                    <BottomActionBar>
                        <View
                            style={{
                                width: '100%',
                                flexDirection: 'row',
                                justifyContent: 'flex-end'
                            }}
                        >
                            {
                                pollID ?
                                    <DarkButton
                                        text={TMenuScreen[AppConfig.lang].POLL}
                                        onPress={() => {
                                            navigate('/admin/survey/results/' + pollID)
                                        }}
                                    />
                                    :
                                    null
                            }
                            <View style={{width: 7}}></View>
                            <ThemeButton
                                style={{
                                    backgroundColor: Styles.basicBackgroundColor.color
                                }}
                                text={TMenuScreen[AppConfig.lang].CUSTOMIZE}
                                onPress={() => {
                                    navigate('/admin/menus/customizer/' + menuID)
                                }}
                            />
                            <View style={{width: 7}}></View>
                            <ThemeButton
                                text={TMenuScreen[AppConfig.lang].EDIT}
                                onPress={() => {
                                    navigate('/admin/menus/editor/' + menuID)
                                }}
                            />
                        </View>
                    </BottomActionBar>
                    :
                    pollID && GetHoursDifference(AppConfig.POLL_ANSWER_DATE_CHECK) >= 4 ?
                        <BottomActionBar>
                            <View
                                style={{
                                    width: '100%',
                                    flexDirection: 'row',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                <ThemeButton
                                    style={{
                                        backgroundColor: config.primaryColor,
                                    }}
                                    textStyle={{
                                        color: GetTextColor(config.primaryColor)
                                    }}
                                    text={TMenuScreen[AppConfig.lang].POLL_MSG}
                                    onPress={() => {
                                        navigate('/public/survey/' + pollID)
                                    }}
                                />
                            </View>
                        </BottomActionBar>
                        :
                        null
            }
        </View>
    );
}

export default PublicMenuScreen;